export function filterByFullname({ user }, search) {
  return user.fullname.toLowerCase().includes(search.toLowerCase())
}
